module.exports = __webpack_public_path__ + "01a94142bddc45b99e3a68eee8839b07.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-shapes/images/oval@2x.png
// module id = 311
// module chunks = 0